import { useEffect } from "react";
import { useImmer } from "use-immer";
import { connectStripeAccountApi, disconnectStripeAccountApi, getStripeConnectDetailApi, getStripeConnectVerifyApi } from "../api/stripeConnectApi";
import { errorMessage, getStoreId, SITE_URL, successMessage } from "../../../utils";
import { useLocation } from "react-router-dom";
import { usePermission } from "../../../shared";

export const useStripeConnectDetails = () => {
    const location = useLocation();
    const isEditable = usePermission("integration-modify");
    const storeId = getStoreId();


    const [state, setState] = useImmer({
        isLoading: true,
        details: {},
        filter: {
            searchText: "",
            status: null,
        },
        isOpenConnect: false,
        isSaveButton: false,
    });

    useEffect(() => {
        if (storeId) {
            getStripeConnectDetails(storeId);
        }
    }, [storeId]);

    const getStripeConnectDetails = async (storeId) => {
        try {
            setState((draft) => {
                draft.isLoading = true;
            });

            const res = await getStripeConnectDetailApi(storeId);

            if (res.success) {
                setState((draft) => {
                    draft.isLoading = false;
                    draft.details = res.data;
                });
            }
        } catch (err) {
            setState((draft) => {
                draft.isLoading = false;
            });
        }
    };



    const handleModal = (type, state, data) => {
        switch (type) {
            case "connect":
                setState((draft) => {
                    draft.isOpenConnect = state;
                });
                break;
            default:
                break;
        }
    }

    const handleStoreConnect = (details) => {
        console.log(details);
        
        if (details.stripe_connect_status == "1") {
            handleStoreDisconnectApi()
        } else {
            handleStoreConnectApi()
        }
    }

    const handleStoreConnectApi = async () => {
        try {
            setState((draft) => {
                draft.isSaveButton = true;
            });
            let redirect_url = `${SITE_URL}store-admin/stripe-connect`;

            const res = await connectStripeAccountApi(state.details.id, redirect_url);

            if (res.success) {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                if (res.data.stripe_connect_url) {
                    window.open(res.data.stripe_connect_url, "_blank");
                }
                handleModal("connect", false, null);
                getStripeConnectDetails(storeId);

            } else {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                errorMessage(res.message);
            }
        } catch (err) {
            setState((draft) => {
                draft.isSaveButton = false;
            });
        }
    }

    const handleStoreDisconnectApi = async () => {

        try {
            setState((draft) => {
                draft.isSaveButton = true;
            });

            const res = await disconnectStripeAccountApi(state.details.stripe_account_id, state.details.id);

            if (res.success) {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                handleModal("connect", false, null);
                getStripeConnectDetails(storeId);

            } else {
                setState((draft) => {
                    draft.isSaveButton = false;
                });
                errorMessage(res.message);
            }
        } catch (err) {
            setState((draft) => {
                draft.isSaveButton = false;
            });
        }
    }



    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const scope = queryParams.get('scope');
        const code = queryParams.get('code');
        const state = queryParams.get('state');

        if (code && scope && state) {
            verifySripeConnect(scope, code, state);

            // Clean the URL after processing the parameters
            const cleanUrl = window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
        }
    }, [location.search]);

    const verifySripeConnect = async (scope, code, state) => {
        try {
            const response = await getStripeConnectVerifyApi(scope, code, state);

            if (response.success) {
                successMessage(response.message);
                // Refresh the list to show the updated connection status
                getStripeConnectDetails(storeId)
            } else {
                errorMessage(response.message);
            }
        } catch (error) {
            errorMessage(error.response?.data?.message);

        };
    }

    return {
        state,
        isEditable,
        handleModal,
        handleStoreConnect,
    };
};
